import {initAutoplayVideo} from '../_extras/video-autoplay';

export default function fiftyFiftyBlock(options = {}) {
	try {
		const {block} = options;
		const video = block?.querySelector('video[data-autoplay]');

		if (!video || block.dataset.fiftyFiftyReady === 'true') return;

		initAutoplayVideo(video, video.hasAttribute('data-hide-controls') ? null : 'fifty-fifty__toggle');
		block.dataset.fiftyFiftyReady = 'true';
	} catch (error) {
		console.error(error);
	}
}
